import { color } from "emoreg/const";

interface DividerProps {
  orientation?: "horizontal" | "vertical";
}
export const Divider = ({ orientation = "horizontal" }: DividerProps) => {
  const borderKey = orientation === "horizontal" ? "borderTop" : "borderLeft";

  return (
    <div
      style={{
        margin: "0",
        borderColor: color.grey.base,
        alignSelf: "stretch",
        [borderKey]: `0.5px solid ${color.grey.base}`,
      }}
    />
  );
};
